import axiosInstance from "../api/axiosInstance"

export const getFeatureRequests  = (params) =>
  axiosInstance.get("/admin/feature-requests", { params });

export const fetchFeatureRequestById = (id) =>
  axiosInstance.get(`/admin/feature-request/${id}`);

export const updateFeatureRequestStatus = (id, data) =>
  axiosInstance.put(`/admin/feature-request/status/${id}`, data);

// One save (2026-09-27): status, internal note and the build it shipped in.
// Nothing is sent to the member.
export const decideFeatureRequest = (id, data) =>
  axiosInstance.put(`/admin/feature-request/decision/${id}`, data);

export const updateFeatureRequest = (id, data) =>
  axiosInstance.put(`/admin/feature-request/${id}`, data);

export const deleteFeatureRequest = (id) =>
  axiosInstance.delete(`/admin/feature-request/${id}`);

export const deleteMultipleFeatureRequests = (ids) =>
  axiosInstance.patch("/admin/feature-request/delete-multiple", { ids });
